import { Tabs } from "antd";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { WITHIN_TABS_STATE } from "../../hooks/useWithinTabs";

const { TabPane } = Tabs;

export const ZM_TABS = {
  ZM: {
    key: "ZM",
    path: "/zm-view",
  },
  ELSTER: {
    key: "ELSTER",
    path: "/zm-view/elster",
  },
};

const SubNavigation = ({ activeTab }: { activeTab: string }) => {
  const { t } = useTranslation("ZmView");
  const navigate = useNavigate();
  const location = useLocation();

  const onChangeTab = useCallback(
    (key: string) => {
      const tab = Object.values(ZM_TABS).find((t) => t.key === key);
      if (tab)
        navigate(tab.path + location.search, { state: WITHIN_TABS_STATE });
    },
    [navigate, location.search]
  );

  return (
    <Tabs type="card" activeKey={activeTab} onChange={onChangeTab}>
      <TabPane tab={t("tabs.zm")} key={ZM_TABS.ZM.key} />
      <TabPane tab={t("tabs.elster")} key={ZM_TABS.ELSTER.key} />
    </Tabs>
  );
};

export default SubNavigation;
